import Container from 'elements/Container'
import React from 'react'
import { THead, TableRow, TableHeader } from './styled'

const Transactions = () => {
  return (
    <Container>
      <div style={{ display: 'table', width: '100%' }}>
        <THead>
          <TableRow>
            <TableHeader>Txn Hash</TableHeader>
            <TableHeader>Method</TableHeader>
            <TableHeader>Block</TableHeader>
            <TableHeader>Age</TableHeader>
            <TableHeader>From</TableHeader>
            <TableHeader>To</TableHeader>
            <TableHeader>Value</TableHeader>
            <TableHeader>Txn Fee</TableHeader>
          </TableRow>
        </THead>
      </div>
    </Container>
  )
}

export default Transactions
